import { render, staticRenderFns } from "./DefaultTemplate.vue?vue&type=template&id=a12892a0&scoped=true"
import script from "./DefaultTemplate.vue?vue&type=script&lang=js"
export * from "./DefaultTemplate.vue?vue&type=script&lang=js"
import style0 from "./DefaultTemplate.vue?vue&type=style&index=0&id=a12892a0&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a12892a0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_testing/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a12892a0')) {
      api.createRecord('a12892a0', component.options)
    } else {
      api.reload('a12892a0', component.options)
    }
    module.hot.accept("./DefaultTemplate.vue?vue&type=template&id=a12892a0&scoped=true", function () {
      api.rerender('a12892a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/common/dashboard/pdp-tabs/DefaultTemplate.vue"
export default component.exports